import { Component, Vue, Prop } from 'vue-property-decorator';

import Buttons from './Buttons.vue';

// @ts-ignore
@Component({
  components: {
    Buttons,
  },
})
export default abstract class ColoredButtons extends Vue {
  @Prop({ required: true }) public value: number;

  public get score(): number {
    return this.value;
  }

  public set score(value: number) {
    this.$emit('input', value);
  }

  public abstract get colors(): string[];
}
